import React from "react";
import { Link } from "react-router-dom";
import "./project.css";

const Media = () => {
    return (
        <div className="container">
            <div className="nav-left nav-left-alt">
                <div className="nav-left-item">
                    <Link to="/work" className="nav-left-link is-black">
                        WORK
                    </Link>
                </div>

                <div className="nav-line is-black"></div>

                <div className="nav-left-item nav-copyright">
                    <div class="copyright">©/2022</div>
                </div>
            </div>

            <div className="content content-work">
                <div className="header-mask header-mask-large">
                    <h1 className="header header-large">Movie App</h1>
                </div>
            </div>

            <div className="wrapper wrapper-small wf-section">
                <div className="work-container">
                    <div className="description-mask">
                        <p className="description description-large">
                            Movie App with Next.js and Login Authentication
                        </p>
                    </div>
                    <figure className="w-richtext-figure-type-image w-richtext-align-fullwidth">
                        <div>
                            <img
                                src="https://i.ibb.co/NVqYmj1/moviesike.jpg"
                                alt="moviesike"
                            />
                        </div>
                    </figure>
                    <p>
                        This project is a movie app that allows users to browse
                        and search for movies by category. The app uses Next.js,
                        a popular React framework, and includes login
                        authentication to secure user data. Users can create an
                        account, log in, and save their favorite movies for
                        later viewing.
                    </p>

                    <p>
                        The app fetches movie data from an external API and uses
                        dynamic routing to display the movie information on
                        separate pages. The user interface is designed to be
                        user-friendly and responsive, with a clean and modern
                        design. This project showcases proficiency in Next.js,
                        React, and API integration, as well as skills in user
                        authentication and dynamic routing.
                    </p>
                </div>
            </div>

            <div className="wrapper wrapper-small wf-section">
                <div className="content-footer">
                    <blockquote class="call-to-action">
                        Check it out.
                    </blockquote>
                    <a
                        href="https://github.com/Mileristov/SikeMovies"
                        target="_blcoank"
                        rel="noreferrer"
                        class="button w-button"
                    >
                        https://github.com/Mileristov/SikeMovies
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Media;
